import { SlotInfo } from '../../../types/schedule.types';

export function isValidCalendarDropTarget(overId: string, optimisticSlots: SlotInfo[]): boolean {
  return (
    overId.startsWith('calendar-day-') ||
    overId.startsWith('slot-insert__') ||
    overId.includes('__note-') ||
    overId.startsWith('note-') ||
    !!optimisticSlots.find((t) => t.slotID === overId)
  );
}
